import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

export interface BenchmarkItem {
  id: string;
  name: string;
  created_at: string;
}

export interface ListBenchmarksResponse {
  benchmarks: BenchmarkItem[];
}

@Injectable({
  providedIn: 'root'
})
export class BenchmarkService {
  private readonly baseUrl = '/api/evaluation';

  constructor(private http: HttpClient) {}

  getBenchmark(): Observable<any> {
    return this.http.get(`${this.baseUrl}/latest`);
  }

  listBenchmarks(): Observable<ListBenchmarksResponse> {
    return this.http.get<ListBenchmarksResponse>(`${this.baseUrl}/`);
  }

  uploadBenchmark(file: File): Observable<BenchmarkItem> {
    const formData = new FormData();
    formData.append('file', file);
    return this.http.post<BenchmarkItem>(`${this.baseUrl}/upload`, formData);
  }

  deleteBenchmark(benchmarkId: string | number): Observable<any> {
    return this.http.delete(`${this.baseUrl}/${benchmarkId}`);
  }

  renameBenchmark(benchmarkId: string | number, name: string): Observable<any> {
    return this.http.patch(`${this.baseUrl}/${benchmarkId}/rename`, { name });
  }

}
